export default __webpack_public_path__ + "static/media/wechat.c0ce7b37.svg";